import type { FilterPill } from '@/app/common/filters/surfaces/bar/pills/types.ts';
import { customPill } from '@/app/common/filters/surfaces/bar/resultsPills/barPills.ts';
import { AllFiltersPill } from '@/app/common/filters/surfaces/bar/resultsPills/AllFiltersPill.tsx';
import { ViewModePill } from '@/app/common/filters/surfaces/bar/resultsPills/ViewModePill.tsx';
import { CUSTOM_GROUP_NAME, FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';

export const createFloatingPillsMap = (): FilterPill[] => [
  customPill({ id: CUSTOM_GROUP_NAME.ALL_FILTERS, CustomPill: AllFiltersPill, withIcon: true }),
];

export const createFloatingPillsViewMode = (): FilterPill[] => [
  customPill({ id: FILTER_NAME.VIEW_MODE, CustomPill: ViewModePill }),
];
